// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Yzx_","fullView":"styles_fullView__3ne1u"};